import { createApi } from '@reduxjs/toolkit/query/react';

import { isNil } from 'lodash';
import { FinancialPlan } from '../types/financialPlan';
import { createBaseQuery } from './api/baseApiConfig';
import config from '../config';

type GetFinancialPlan = {
	companyId: string | null;
};

const Tags = {
	FinancialPlan: 'financialPlan',
};

export const financialPlanApi = createApi({
	reducerPath: 'financialPlan',
	baseQuery: createBaseQuery(`${config.APIM_BASE_URL}/${config.INSTRUMENT_API_URL}`),
	tagTypes: [Tags.FinancialPlan],
	endpoints: builder => ({
		getFinancialPlan: builder.query<FinancialPlan, GetFinancialPlan>({
			query: ({ companyId }: GetFinancialPlan) => {
				if (isNil(companyId)) {
					throw new Error('parameter error');
				}

				return {
					method: 'GET',
					url: `/timeline/${companyId}?isDraft=true`,
				};
			},
			transformResponse: (response: FinancialPlan) => {
				// Create a new object without instruments and projects
				const { instruments, projects, ...rest } = response;
				return rest as FinancialPlan;
			},
			providesTags: (_data: any, _error: any, params: GetFinancialPlan) => {
				return [{ type: Tags.FinancialPlan, id: params?.companyId ?? '' }];
			},
		}),
	}),
});

export const { useGetFinancialPlanQuery } = financialPlanApi;
